import { Box, TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { VendorOnboardingForm } from '../../interfaces'
import { normaliseAlnum, validateEmail, validatePan } from '../../validators'
import { FieldGrid, StageHeading, textFieldSx } from '../StepChrome'

const CompanyStep = () => {
    const { control } = useFormContext<VendorOnboardingForm>()

    return (
        <Box>
            <StageHeading
                title="Company information"
                blurb="Tell us who we're onboarding."
            />

            <FieldGrid>
                <Controller
                    control={control}
                    name="companyName"
                    rules={{ required: 'Company name is required' }}
                    render={({ field, fieldState }) => (
                        <TextField
                            {...field}
                            label="Company name *"
                            fullWidth
                            sx={{ ...textFieldSx, gridColumn: { sm: '1 / -1' } }}
                            error={Boolean(fieldState.error)}
                            helperText={
                                fieldState.error?.message ??
                                'Registered legal name, as it appears on your GST certificate'
                            }
                        />
                    )}
                />

                <Controller
                    control={control}
                    name="panNumber"
                    rules={{ validate: validatePan }}
                    render={({ field, fieldState }) => (
                        <TextField
                            {...field}
                            onChange={(event) =>
                                field.onChange(normaliseAlnum(event.target.value, 10))
                            }
                            label="PAN number *"
                            fullWidth
                            sx={textFieldSx}
                            inputProps={{ style: { textTransform: 'uppercase' } }}
                            error={Boolean(fieldState.error)}
                            helperText={
                                fieldState.error?.message ?? '10 characters, e.g. ABCDE1234F'
                            }
                        />
                    )}
                />

                <Controller
                    control={control}
                    name="submitterEmail"
                    rules={{ validate: validateEmail }}
                    render={({ field, fieldState }) => (
                        <TextField
                            {...field}
                            label="Your email *"
                            type="email"
                            fullWidth
                            sx={textFieldSx}
                            error={Boolean(fieldState.error)}
                            helperText={
                                fieldState.error?.message ??
                                "We'll email your submission summary here"
                            }
                        />
                    )}
                />
            </FieldGrid>
        </Box>
    )
}

export default CompanyStep
